<template>
  <div class="avatar">
    <div
      v-if="hasImage"
      class="image"
      :style="{ 'background-image': 'url(' + src + ')' }"
    />

    <div v-if="letter" class="letter">
      {{ letter }}
    </div>

    <i v-else class="fas fa-user"></i>
  </div>
</template>

<script>
import md5 from 'md5';

export default {
  name: 'Avatar',

  props: {
    imageUrl: String,
    name: String,
    email: String,
    size: {
      type: [Number, String],
      default: 100,
    },
  },

  computed: {
    hasImage() {
      return Boolean(this.src);
    },

    letter() {
      return this.name && this.name.length ? this.name.charAt(0) : null;
    },

    src() {
      return this.imageUrl ? this.imageUrl : this.gravatarImg;
    },

    gravatarImg() {
      if (this.email) {
        const hash = md5(this.email.trim().toLowerCase());

        return `//www.gravatar.com/avatar/${hash}?s=${this.size}&d=blank`;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .avatar {
    @include circle(px-to-rem(40px));
    background-color: $primary-color;
    color: $white-color;

    height: var(--avatar-size, px-to-rem(40px));
    width: var(--avatar-size, px-to-rem(40px));
    font-size: calc(var(--avatar-size, px-to-rem(40px)) / 2);
    overflow: hidden;
    flex-shrink: 0;
    position: relative;
  }

  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 50%;
    height: var(--avatar-size, px-to-rem(40px));
    width: var(--avatar-size, px-to-rem(40px));
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
